module.exports = __webpack_public_path__ + "/df41c6bc1e5e178f05c46e94b34e11e7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/images/logo@2x.png
 ** module id = 1091
 ** module chunks = 0
 **/